export default function areAnyCategoryIdsExclusive(
  categoryIds: Array<number>,
): boolean {
  return VisitWidget.store.exclusiveCategories.some(
    (category: { id: number }) => categoryIds.includes(category.id),
  );
}
